module.exports = function getResource(label, vars = []) {
    let resources = {
        beautyServices: 'FAQ sur les services beauté',
        happeningAtSephora: 'En cours chez Sephora',
        makeupServices: 'Services de maquillage'
    };

    return resources[label];
};
